(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["janexx-product-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.currentScript.closest('[data-jx-slider]');
  if(!root) return;

  const track = root.querySelector('[data-jx-track]');
  const dotsWrap = root.querySelector('[data-jx-dots]');
  const slides = [...root.querySelectorAll('[data-jx-slide]')];

  if(!track || slides.length < 2) return;

  dotsWrap.innerHTML = '';
  const dots = slides.map((_, i) => {
    const b = document.createElement('button');
    b.className = 'jx-dot';
    b.addEventListener('click', () => {
      slides[i].scrollIntoView({behavior:'smooth',inline:'start'});
    });
    dotsWrap.appendChild(b);
    return b;
  });

  const update = () => {
    let index = 0;
    let min = Infinity;
    slides.forEach((s,i)=>{
      const d = Math.abs(s.offsetLeft - track.scrollLeft);
      if(d < min){min=d;index=i;}
    });
    dots.forEach((d,i)=>d.setAttribute('aria-current', i===index));
  };

  track.addEventListener('scroll', ()=>requestAnimationFrame(update), {passive:true});
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
